/**
 * Supported ARS set types for the shared picker/window components.
 */
export const ARS_SET_TYPES = {
  analysisMethod: {
    value: "analysisMethod",
    selectLabel: "Select analysis method",
    glyphText: "AM",
  },
  analysisSet: {
    value: "analysisSet",
    selectLabel: "Select analysis set",
    glyphText: "AS",
  },
  dataSubset: {
    value: "dataSubset",
    selectLabel: "Select data subset",
    glyphText: "DS",
  },
  groupingFactor: {
    value: "groupingFactor",
    selectLabel: "Select grouping factor",
    glyphText: "GF",
  },
};

export type ArsSetType = keyof typeof ARS_SET_TYPES;
